export default "__VITE_ASSET__yJycNkp8__"